import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

export type StatDeltaDirection = 'up' | 'down' | 'none';

@Component({
  selector: 'xemex-stat-card',
  standalone: true,
  imports: [MatIconModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './stat-card.component.scss',
  templateUrl: './stat-card.component.html',
})
export class StatCardComponent {
  label = input.required<string>();
  value = input.required<string | number>();
  /** Change string, e.g. "+5" or "-3h". Omit to hide the delta row. */
  delta = input<string>();
  deltaLabel = input<string>();
  /** Which direction counts as an improvement — drives the arrow colour. */
  deltaGood = input<StatDeltaDirection>('none');
  /** Secondary line shown instead of a delta, e.g. "Avg 2.1 / day". */
  secondary = input<string>();
  /** `row` (default): label left of a medium value, used for the Alarms overview KPI row.
   * `stacked`: a large value above a small uppercase caption label, no delta/secondary row —
   * for a small set of headline KPI tiles (e.g. the dashboard's top row). */
  layout = input<'row' | 'stacked'>('row');
  /** `md` (default) uses the standard heading token for the value. `lg` bumps value/label to
   * the next token size up — for headline tiles that need to stand out more (e.g. a dashboard
   * KPI row where the label sits beside the number). */
  size = input<'md' | 'lg'>('md');

  protected get isDeltaUp(): boolean {
    const delta = this.delta();
    return !delta || !delta.startsWith('-');
  }

  protected get isDeltaGood(): boolean {
    const good = this.deltaGood();
    if (good === 'none') return true;
    return good === 'up' ? this.isDeltaUp : !this.isDeltaUp;
  }
}
